import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'VenueCourt';

const VenueCourtApi: any = baseApi(endpoint);

export default VenueCourtApi;